/** Une lecture ancienne ne doit pas réécrire les compteurs après la suivante. */
export function latestLoad(): () => (commit: () => void) => void {
  let sequence = 0;
  return () => {
    const current = ++sequence;
    return (commit) => { if (current === sequence) commit(); };
  };
}
